define('models/user/changepassword/changepassword',[ 'backbone' ], function(Backbone){

    var ChangePassword = Backbone.Model.extend({
        urlRoot: function(){
            return pf.userURL + '/UpdatePassword';
        },
        initialize: function(options){
            options || (options = {});

            this.UserGUID = options.UG;
            this.CurrentPassword = options.CP;
            this.NewPassword = options.NP;
        },
        parse: function(data){
            var response = {};
            response.UserGUID = data.UG;
            response.CurrentPassword = data.CP;
            response.NewPassword = data.NP;
            return response;
        },
        save: function(attributes, options){
            options = options || {};
            attributes = attributes || {};

            var data = {};
            data.UG = pf.session.get('UserGUID');
            data.CP = this.attributes.CurrentPassword;
            data.NP = this.attributes.NewPassword;
              
            this.attributes = data;
            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return ChangePassword;
});

